// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"91c81d3f","707":"3424a9dc","729":"2d86c3b7"}[chunkId] + ".js";
};